import { styled } from '@mui/material/styles';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { PropsWithChildren } from 'react';

type IProps = Pick<TypographyProps, 'sx'>;

const StyledSubtitle = styled(Typography)`
    text-align: center;
`;

export const Subtitle = ({ sx, children }: PropsWithChildren<IProps>) =>
    children ? (
        <StyledSubtitle variant="body2" sx={sx} data-testid="drawerSubtitle">
            {children}
        </StyledSubtitle>
    ) : null;
